import { gql } from '@apollo/client';

export const UPDATE_SURFACE_WATER_MONITOR = gql`
    mutation UpdateSurfaceWaterMonitor($id: Guid!, $input: UpdateSurfaceWaterMonitor!) {
        facility {
            process {
                updateSurfaceWaterMonitor(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
